import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { Competition } from '@ilteducation/competition-referee-types';
import { defaultRealms } from '@/foundations/helpers/defaultRealms';

type Props = {
  id?: string;
  title: string;
  item?: Competition;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  props: {
    id: null,
    title: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
  id?: string;
  title: string;
  item?: Competition;
}



const availableMarkets = ref(defaultRealms);

const realm = ref<string | undefined>(
  props.item?.realm ? defaultRealms.find((r) => r.code === props.item?.realm)?.code : undefined,
);

return { __sfc: true,props, availableMarkets, realm }
}

})